<template>
  <div class="icon-medsos">
    <ul>
      <li>
        <a href="https://www.linkedin.com/in/bintangmochamadyussuf/" target="blank"><i class="fa-brands fa-linkedin-in fa-inverse"></i></a>
      </li>
      <li>
        <a href="https://www.instagram.com/bintang_mochamad/" target="blank"><i class="fa-brands fa-instagram fa-inverse"></i></a>
      </li>
      <li>
        <a href="https://github.com/BintangMy" target="blank"><i class="fa-brands fa-github fa-inverse"></i></a>
      </li>
    </ul>
    <span class="line"> </span>
  </div>
</template>

<script>
export default {
  name: "media-sosial",
};
</script>

<style lang="scss">
.icon-medsos {
  position: absolute;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-decoration: none;

  ul {
    list-style-type: none;
    padding: 0;
    margin: 0;

    li {
      color: white;
      margin: 1rem;
      font-size: 1.2rem;
    }
    i:hover{
        color: #00f2ea;
    }
  }
}

.line {
  background-color: white;
  height: 6rem;
  width: 0.1rem;
  margin-left: 1.6rem;
}
</style>
